import React, { Component } from "react";
import { node, string, bool } from "prop-types";

import AccordionItem from "pages/_components/AccordionItem";

export const AccordionContext = React.createContext();

class Accordion extends Component {
    static propTypes = {
        children: node.isRequired,
        className: string,
        expandAll: bool,
        numberToExpand: string,
    };

    static defaultProps = {
        className: "navigational-list",
        expandAll: null,
        numberToExpand: null,
    };

    state = {
        itemOpen: null,
    };

    componentDidUpdate(prevProps) {
        const { expandAll, numberToExpand } = this.props;
        if (expandAll !== null) {
            if (prevProps.expandAll && !expandAll) {
                this.clearItemOpen();
            }
        }
        if (numberToExpand !== null) {
            if (prevProps.numberToExpand && !numberToExpand) {
                this.clearItemOpen();
            }
        }
    }

    clearItemOpen = () => {
        this.setState({ itemOpen: null });
    };

    handleClick = (number) => {
        const { itemOpen } = this.state;

        if (number === itemOpen) {
            this.setState({ itemOpen: null });
        } else {
            this.setState({ itemOpen: number });
        }
    };

    static Item = AccordionItem;

    render() {
        const { className, children, expandAll, numberToExpand } = this.props;
        const { itemOpen } = this.state;

        return (
            <AccordionContext.Provider value={{ itemOpen, onClick: this.handleClick, expandAll, numberToExpand }}>
                <ul className={className}>{children}</ul>
            </AccordionContext.Provider>
        );
    }
}

export default Accordion;
